global.openModal = null;

document.addEventListener("DOMContentLoaded", function(){

    let modal = document.querySelector('.js-modal');
    let body = document.querySelector('body');
    if (modal) {

        let closeModal = document.querySelectorAll('.js-close-modal');
        let modalContent = document.querySelectorAll('.js-modal-content');

        if (window.location.href == window.location.protocol + "//" + window.location.host + "/newsroom/#subscribe") {
            expandModalContent("subscribe");
        }

        function openModalContent(name, expanded) {
            modalContent.forEach(content => {

                if (! expanded )
                {
                    content.classList.remove('visible');
                }
                /* Set modal content */
                if (content.dataset.content == name) {
                    content.classList.add('visible');
                    content.dispatchEvent(new CustomEvent('openModal'));
                }

                modal.classList.add('modal-lightbox--open');
                body.classList.add('disable-scroll');
            });
        }

        function expandModalContent(name) {
            openModalContent(name, true);
        }

        function openMenuContent(menu, closeAll) {
            openModalContent('popup-menu');

            closeAll = closeAll === undefined ? true : closeAll

            if (closeAll)
            {
                $('.modal-menu').removeClass('active');
            }
            let $menu = $('#' + menu)
            let depth = $menu.data('depth');

            let $activeItems = $('.modal-menu.active');

            if (depth)
            {
                $activeItems.filter(function () {
                    return $(this).data('depth') >= depth;
                }).removeClass('active');
            }

            $menu.addClass('active');

            if (! $activeItems.filter('.first-active').length)
            {
                $menu.addClass('first-active');
            }

            modal.classList.add('with-menu');
        }

        function backLastNavigation() {
            let elements = document.querySelectorAll('.modal-menu.active');
            if (elements.length)
            {
                let last = elements[elements.length - 1];
                last.classList.remove('active');

                if (elements.length <= 1)
                {
                    modal.dispatchEvent(closeModalEvent);
                }
            }

        }

        global.openModal = openModalContent;
        global.expandModalContent = expandModalContent

        $('body').on('click', '.js-open-modal', function (e) {
            var btn = this;
            e.preventDefault();
            e.stopPropagation();

            openModalContent(btn.dataset.modal)
            
            // Select subject and trigger click on the select element
            var selectSubjectOption = btn.dataset.selectedSubject;
            if (selectSubjectOption) {
                $('#subject')
                    .val(selectSubjectOption)
                    .trigger('click');
            }

            if ( btn.dataset.modal == 'report' )
            {
                document.getElementById('report-id').value = btn.dataset.id;
            }
        });

        $('body').on('click', '.js-open-menu', function (e) {
            if (this.dataset.menu)
            {
                e.preventDefault();
                e.stopPropagation();
                openMenuContent(this.dataset.menu)
            }

        });

        let modalParents = document.querySelectorAll('.js-open-modal-child');
        let menuBackButtons = document.querySelectorAll('.js-menu-back');

        menuBackButtons.forEach(el => {
            el.addEventListener('click', function (e) {
                backLastNavigation();
            });
        })

        modalParents.forEach(el => {
            el.addEventListener('click',function(e){

                e.preventDefault();
                e.stopPropagation();

                let menuId = el.getAttribute('data-child-menu');
                let menu = menuId ? 'menu-' + menuId : null;

                document.querySelectorAll('.icon-btn').forEach(btn => {
                    btn.classList.remove('active-btn');
                });

                el.querySelector('.icon-btn').classList.add('active-btn');

                if (menu)
                {
                    openMenuContent(menu, false);
                }
            })
        })

        $('[data-modal=suggest]').click(function (e) {
            e.preventDefault();
            e.stopPropagation();

            openModalContent('suggest');
        });

        let closeModalEvent = new CustomEvent('closeModal');



        modal.addEventListener('click',function(e){
            e.stopPropagation();

            if (e.target)
            {
                let array = Array.from(closeModal);
                let valid = array.some(function (el) {
                    return e.target == el || el.contains(e.target);
                });

                if ( valid || e.target == modal ) {

                    modal.dispatchEvent(closeModalEvent);
                }
            }
        });

        modal.addEventListener('closeModal', function (e) {

            hideToast()

            modal.classList.remove('modal-lightbox--open');
            modal.classList.remove('with-menu');
            body.classList.remove('disable-scroll');

            modalContent.forEach(content => {
                content.classList.remove('visible', 'active-child');
            });

            document.querySelector('.modal-inner').classList.remove('active-modal-child');
            document.querySelectorAll('.icon-btn').forEach(btn => {
                btn.classList.remove('active-btn');
            });

            $('.modal-menu.first-active').removeClass('first-active');
        });
    }

    let selects = document.querySelectorAll('select');

    selects.forEach(el => {
        el.addEventListener('click',function(e){
            el.parentNode.classList.remove('completed');
            el.parentNode.classList.add('active');
        })

        el.addEventListener("change", function(){
            var elem = (typeof this.selectedIndex === "undefined" ? window.event.srcElement : this);
            var value = elem.value || elem.options[elem.selectedIndex].value;

            el.parentNode.classList.remove('active');

            if ( value === '' || typeof value === 'undefined' ) {
                el.parentNode.classList.remove('completed');
            } else {
                el.parentNode.classList.add('completed');
            }
        });
    })

    /* Copy link */
    let copyLinkBtn = document.querySelectorAll('.js-copy-link');
    let toast = document.querySelector('.js-toast');

    if (copyLinkBtn.length > 0) {

        copyLinkBtn.forEach(btn => {

            btn.addEventListener('click',function(e){
                e.preventDefault;
                copyToClipboard();
            });
        });
    }

    toast.addEventListener('click',function(e){
        hideToast();
    });

    function copyToClipboard() {
        var inputc = document.body.appendChild(document.createElement("input"));
        inputc.value = window.location.href;
        inputc.select();
        document.execCommand('copy');
        inputc.parentNode.removeChild(inputc);

        /* Show toast */
        toast.classList.add('active');
        setTimeout(() => {
            hideToast()
        }, 3000);
    }

    function hideToast() {
        toast.classList.remove('active');
    }

});
